import { api } from '@/services';

import {
  IIpadConfigDetails,
  IIpadSerialNumberSearchResponse,
  IIpadConfig,
  IIpadConfigsSearchingPayload,
} from '@/features/ipad-configs/interfaces';
import { DEVICES_API_ENDPOINTS } from '@/constants';
import { ApiResponse, PagedResponse } from '@/types';
import { IDropdownSearchOption } from '@/components/common/DropdownSearch';

const IpadConfigService = {
  GetIpadConfig: async (serialNumber: string): Promise<ApiResponse<IIpadConfigDetails>> => {
    const response = await api.get(
      DEVICES_API_ENDPOINTS.DEVICES_SERIAL.replace(':serialNumber', serialNumber),
    );
    return response.data;
  },
  GetIpadSerialNumbers: async (
    searchValue: IDropdownSearchOption,
  ): Promise<ApiResponse<IIpadSerialNumberSearchResponse>> => {
    const response = await api.post(DEVICES_API_ENDPOINTS.DEVICES_CURSOR, searchValue);
    return response.data;
  },

  DevicesSearching: async (
    payload: IIpadConfigsSearchingPayload,
  ): Promise<PagedResponse<IIpadConfig>> => {
    const response = await api.post<ApiResponse<PagedResponse<IIpadConfig>>>(
      DEVICES_API_ENDPOINTS.DEVICES_SEARCHING,
      payload,
    );
    return response.data.data;
  },
};

export default IpadConfigService;
